import {Option} from '../interfaces/misc';
import {makeEl} from '../ts-lib/functions';

export interface Params {
    name: string;
    title: string;
    options: Option[];
    label?: HTMLLabelElement,
    class?: string
}

export class Multiselect {
    params: Params;

    selected: Option[] = [];

    container: HTMLElement;
    label: HTMLLabelElement;
    input: HTMLInputElement;
    selectedField: HTMLElement;
    selectOptions: HTMLSelectElement;

    focusTimeout: NodeJS.Timeout;

    constructor(params?: Params) {
        this.params = params;
        this.createElements();
        this.initListeners();
    }

    get() {
        return this.container;
    }

    createElements() {
        if (this.params?.label) {
            this.label = this.params.label;
            this.label.htmlFor = 'options-selector';
        } else {
            this.label = makeEl('label', this.params.title, null, {for: 'options-selector'}) as HTMLLabelElement;
        }
        this.container = makeEl('div', null, null, {class: ['multiselect']});
        this.selectedField = makeEl('div', null, null, {class: ['selected-field']});
        this.input = makeEl('input', null, null, {
            id: this.params.name,
            type: 'hidden',
            name: this.params.name
        }) as HTMLInputElement;
        this.selectOptions = this.createOptions() as HTMLSelectElement;
        this.container.append(this.label, this.selectedField, this.input, this.selectOptions);

        if (this.params?.class) {
            this.input.classList.add(this.params.class);
        }
    }

    initListeners() {
        this.selectedField.addEventListener('click', () => this.toggleList());
        this.label.addEventListener('click', () => this.toggleList());
        this.selectOptions.addEventListener('focusin', () => this.toggleList(), true);
        this.selectOptions.addEventListener('focusout', () => this.toggleList(true), true);
    }

    createOptions() {
        let select = makeEl('select', null, null, {
            id: 'options-selector',
            class: ['options'],
            name: 'opt-selector'
        });
        select.style.display = 'none';
        if (this.params?.options?.length) {
            this.params.options.forEach(o => {
                let opt = makeEl('option', o.title, null, {
                    class: ['option'],
                    value: o.value,
                    data: [{name: 'id', val: o.value}]
                });
                opt.addEventListener('click', (e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    this.toggleOption(o);
                })
                select.append(opt);
            })
        }
        return select;
    }

    toggleList(hide = false) {
        let display = this.selectOptions.style.display;
        if (display === 'none') {
            this.selectOptions.style.display = 'block';
            this.selectOptions.focus();
        } else if (hide) {
            // this.input.blur();
            this.focusTimeout = setTimeout(() => {
                this.selectOptions.style.display = 'none';
            }, 300)
        }
    }

    toggleOption(option: Option) {
        clearTimeout(this.focusTimeout);
        let selected = this.selected.find(o => o.value === option.value);
        let li = this.selectOptions.querySelectorAll(`.option[data-id="${option.value}"]`)[0];

        if (selected) {
            let i = this.selected.indexOf(selected);
            this.selected.splice(i, 1);
            li.classList.remove('selected');
        } else {
            this.selected.push(option);
            li.classList.add('selected');
        }

        this.showSelected();
    }

    showSelected() {
        let ids: string[] = [];
        this.selectedField.innerHTML = '';
        this.selected.forEach(o => {
            let el = makeEl('span', o.title, null, {class: ['selected-el']});
            let remover = makeEl('span', null, '&#10006;', {class: ['remover']});
            remover.addEventListener('click', () => {
                this.toggleOption(o);
            });
            el.append(remover);
            this.selectedField.append(el);
            ids.push(o.value.toString());
        })

        this.input.value = ids.join(',');
    }
}